__turbopack_context__.v({
  "page-wrapper": "Print-module-scss-module___IqIqW__page-wrapper",
  "print-wrapper": "Print-module-scss-module___IqIqW__print-wrapper",
  "svg-label-wrapper": "Print-module-scss-module___IqIqW__svg-label-wrapper",
});
